import { Articolo } from "./Articolo";

export class ArticoloCollegatoArticolo {
    quantita!: number;
    mostraMenu!: boolean;
    articolo?: Articolo;

    static fromJson(json: any) {
        let result = new ArticoloCollegatoArticolo();
        result.quantita = parseFloat(json.quantita);
        result.mostraMenu = json.mostraMenu;

        if (json.articolo) {
            result.articolo = Articolo.fromJson(json.articolo);
        }

        return result;
    }
}
